<template>
  <article class="post post--card post--news">
    <div v-html="article.images"></div>
    <a :href="article.url">
      <div class="post__details">
        <h2 class="post__title">{{ article.title }}</h2>
        <p class="post__meta">
          <time :datetime="article.datetime_attr" :content="article.content_attr">
            {{ article.formatted_date }}
          </time>
        </p>
        <p class="post__summary" v-html="article.precis"></p>
      </div>
    </a>
  </article>
</template>
<script>
  export default {
    props: {
      article: Object
    },
    computed: {
      hasDate() {
        return this.article.hasOwnProperty('');
      }
    },
  }
</script>
